import { filterAlertsInbox } from '../features/invoices-reports/alertsInbox.js';
import type { AlertItem } from '../features/invoices-reports/invoicesReportsApi.js';
import { isPendingApproval } from '../features/policies-approvals/approvalFastPath.js';
import type { ApprovalRequest } from '../features/policies-approvals/policiesApprovalsApi.js';

/** Badge counts for the Approvals rail item only (alerts live on the header bell). */
export function navBadgeMap(approvalCount: number): Record<string, number> {
  const map: Record<string, number> = {};
  if (approvalCount > 0) map['/approval-queue'] = approvalCount;
  return map;
}

/** Prefer the account pending count; otherwise count still-open rows only (NAV-2). */
export function pendingApprovalBadgeCount(
  accountCount: number | null | undefined,
  approvals: Array<Pick<ApprovalRequest, 'status' | 'state'>>,
): number {
  if (typeof accountCount === 'number' && Number.isFinite(accountCount)) {
    return Math.max(0, Math.trunc(accountCount));
  }
  return approvals.filter((row) => isPendingApproval(row)).length;
}

/** Unread 031 facts only — approval *requests* stay on the Approvals badge. */
export function bellUnreadCount(alerts: AlertItem[]): number {
  return filterAlertsInbox(alerts, { unreadOnly: true }).length;
}
